export default __webpack_public_path__ + "static/media/ico_clinic_disabled.3b47e4d9.svg";